import { t } from '@lingui/macro';
import { BookingCategory } from 'noddi-util';

export const translateBookingCategories = (bookingCategoryFromApi: BookingCategory | string): string => {
  switch (bookingCategoryFromApi) {
    case BookingCategory.WHEEL_SERVICES:
      return t`Wheel services`;
    case BookingCategory.WASH_SERVICES:
      return t`Wash services`;
    case BookingCategory.PACKAGES:
      return t`Packages`;
    default:
      return t`Other`;
  }
};
